document.addEventListener("DOMContentLoaded", function () {
    // Support both old class name and new section-specific class names
    const stickyBar = document.querySelector(".c-sticky-atc-bar") || document.querySelector('[class*="sticky-atc-bar--"]');
    
    if (!stickyBar) return;
    
    // Get scroll threshold from data attribute or use default
    const scrollThreshold = parseInt(stickyBar.getAttribute('data-scroll-threshold') || '680') || 680;
    const stickyBtn = stickyBar.querySelector('.sticky-atc-bar__btn');
    
    window.addEventListener("scroll", function () {
      const windowTop = window.scrollY;
  
      if (windowTop >= scrollThreshold) {
        stickyBar.classList.add("is-sticky");
      } else {
        stickyBar.classList.remove("is-sticky");
      }
    });
    
    if (!stickyBtn) return;

    // Sync Sticky ATC button with main ATC button
    const updateStickyBtn = () => {
      // Find all potential ATC buttons
      const candidates = document.querySelectorAll('button[name="add"]');
      let mainAtcBtn = null;

      // 1. Prioritize visible button inside product-form-component
      for (const btn of candidates) {
        if (btn.closest('product-form-component') && btn.offsetParent !== null) {
          mainAtcBtn = btn;
          break;
        }
      }
      
      // 2. Fallback to any visible button
      if (!mainAtcBtn) {
         for (const btn of candidates) {
            if (btn.offsetParent !== null) {
               mainAtcBtn = btn;
               break;
            }
         }
      }

      // 3. Fallback to first button found (if nothing visible)
      if (!mainAtcBtn && candidates.length > 0) mainAtcBtn = candidates[0];
      
      if (!mainAtcBtn) {
        console.warn('Sticky ATC: No main ATC button found');
        return;
      }

      const isDisabled = mainAtcBtn.hasAttribute('disabled') || mainAtcBtn.disabled || mainAtcBtn.classList.contains('disabled');
      // Get visible text, excluding price if possible, or just take innerText
      // The structure is usually: <span class="add-to-cart-text__content">Text <span class="price">...</span></span>
      // We want just the text.
      let mainText = mainAtcBtn.innerText.trim();
      
      // Try to get cleaner text from the text content span if it exists
      const textSpan = mainAtcBtn.querySelector('.add-to-cart-text__content');
      if (textSpan) {
        // Clone to remove price without affecting DOM
        const clone = textSpan.cloneNode(true);
        const price = clone.querySelector('.button-price');
        if (price) price.remove();
        mainText = clone.textContent.trim();
      }

      console.log('Sticky ATC Sync:', { mainAtcBtn, isDisabled, mainText });

      // Update text
      if (isDisabled) {
         stickyBtn.textContent = mainText || 'Sold Out';
      } else {
         stickyBtn.textContent = stickyBtn.dataset.defaultText || 'Add to Cart';
      }

      // Update disabled state
      if (isDisabled) {
        stickyBtn.classList.add('disabled');
        stickyBtn.setAttribute('aria-disabled', 'true');
        stickyBtn.style.pointerEvents = 'none';
        stickyBtn.style.opacity = '0.5';
        stickyBtn.removeAttribute('href');
      } else {
        stickyBtn.classList.remove('disabled');
        stickyBtn.removeAttribute('aria-disabled');
        stickyBtn.style.pointerEvents = '';
        stickyBtn.style.opacity = '';
        if (!stickyBtn.hasAttribute('href')) {
             stickyBtn.setAttribute('href', '#'); 
        }
      }
    };

    // Initial sync
    updateStickyBtn();

    // Observe MainContent for changes to catch button replacements and attribute updates
    const mainContent = document.getElementById('MainContent') || document.body;
    
    const observer = new MutationObserver((mutations) => {
      // Debounce could be added here if performance is an issue, but for now direct call is safer for responsiveness
      updateStickyBtn();
    });

    observer.observe(mainContent, { 
      childList: true, 
      subtree: true, 
      attributes: true, 
      attributeFilter: ['disabled', 'class', 'aria-disabled', 'data-sold-out'] 
    });
});